<template>
	<section
		class="create--wrap"
		id="create"
		:class="{shadowBottom: !generatedCode}"
	>
		<div class="wrapper create flex justify-between">
			<div class="create__form">

				<p class="create__form__title">
					{{ $t('createForm.title') }}
				</p>

				<base-dropdown
					:settings="templateSettings"
					:listItems="templateSettings.lists"
					@click="changeTemplate"
				></base-dropdown>

				<transition-group name="height" tag="div">
					<base-input
						v-for="(item, key, index) in inputsSettings" :key="`key-${index}`"
						:settings="item" v-model="formData[key]"
						v-if="!item.visibleId || item.visibleId === templateId"
					></base-input>
				</transition-group>

			</div>

			<div class="create__preview">
				<cropper :formData="generateFormData" :templateId="templateId"></cropper>
			</div>

		</div>
	</section>
</template>

<script>

	import { emailValidator } from "@/plugin/inputMixins";

	export default {

		data() {
			return {
				templateId: null,
				formData: {
					name: null,
					position: null,
					company: null,
					email: null,
					companyAddress: null,
					site: null
				},
				templateSettings: {
					translation: {
						title: 'createForm.formData.template',
						defaultValue: 'createForm.formData.templatePlaceholder',
						errorText: ''
					},
					condition: {
						error: false,
					},
					lists: [
						{
							id: 1,
							key: '1',
							translate: 'createForm.formData.templateList.ordinary'
						},
						{
							id: 2,
							key: '2',
							translate: 'createForm.formData.templateList.support'
						}
					]
				},
				inputsSettings: {
					name: {
						translation: {
							title: 'createForm.formData.name',
							placeholder: 'createForm.formData.namePlaceholder',
							errorText: 'createForm.formData.baseError'
						},
						condition: {
							error: false,
							isRequired: true
						}
					},
					position: {
						translation: {
							title: 'createForm.formData.position',
							placeholder:'createForm.formData.positionPlaceholder',
							errorText: 'createForm.formData.baseError'
						},
						condition: {
							error: false,
							isRequired: true
						}
					},
					company: {
						translation: {
							title: 'createForm.formData.company',
							placeholder: 'createForm.formData.companyPlaceholder',
							errorText: 'createForm.formData.baseError'
						},
						condition: {
							error: false,
							isRequired: true
						}
					},
					email: {
						translation: {
							title: 'createForm.formData.email',
							placeholder: 'createForm.formData.emailPlaceholder',
							errorText: 'createForm.formData.emailError'
						},
						condition: {
							error: false,
							isRequired: true
						}
					},
					companyAddress: {
						translation: {
							title: 'createForm.formData.companyAddress',
							placeholder: 'createForm.formData.companyAddressPlaceholder',
							errorText: 'createForm.formData.baseError'
						},
						condition: {
							error: false,
							isRequired: true
						},
						visibleId: 2
					},
					site: {
						translation: {
							title: 'createForm.formData.site',
							placeholder: 'createForm.formData.sitePlaceholder',
							errorText: 'createForm.formData.baseError'
						},
						condition: {
							error: false,
							isRequired: true
						},
						visibleId: 2
					}
				}
			}
		},
		computed: {
			userEmail() {
				return this.formData.email
			},
			generateFormData() {
				return this.templateId === 1
					? Object.keys(this.formData)
						.filter(key => !key.includes('companyAddress') && !key.includes('site'))
						.reduce((acc, key) => ({...acc, ...{[key]: this.formData[key]}}), {})
					: this.formData;
			},
			generatedCode() {
				return this.$store.state.generatedCode;
			}
		},
		methods: {
			changeTemplate(e) {
				this.templateId = e.id
			}
		},
		watch: {
			userEmail(val) {
				this.validateEmail(val.trim())
			}
		},
		components: {
			baseInput: () => import('Components/subComponents/baseInput'),
			baseDropdown: () => import('Components/subComponents/baseDropdown'),
			cropper: () => import('Components/cropper')
		},
		mixins: [emailValidator]

	}

</script>